// Week 6 / Day 3 — Вода, питание, обратные проценты и уравнения / Water, Food, Inverse Percent and Equations
// Solid Grade 6 math + RU Grade 3–4.

export const maxWeek6Day3 = {
  id: 'max-week-6-day-3',
  studentId: 'max',
  weekId: 'week-6',
  dayId: 'day-3',
  title: 'Вода, питание, обратные проценты и уравнения / Water, Food, Inverse Percent and Equations',
  shortTitle: 'Вода и уравнения / Water and Equations',
  theme:
    'Макс анализирует воду и питание через литры, проценты, таблицы и уравнения. / Max analyses water and food through liters, percent, tables and equations.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни ведёт Макса через десятичные литры, обратный процент по воде и уравнение с бутылками. / Nimny walks Max through decimal liters, inverse percent and a bottle equation.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: десятичные, литры/миллилитры, проценты, обратный процент, уравнение (Grade 6). / decimals, L/mL, percent, inverse percent, equations.',
    'Слой 2. Русский / Layer 2. Russian: безударные, исправление, части речи. / unstressed, correction, parts of speech.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст об измерениях + план + 4 предложения.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: «просто пить больше» vs записывать литры.',
    'Слой 5. Практика: свой food/water log за день. / Practical: own food/water log for one day.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'литр / liter', definition: 'единица объёма (1 л = 1000 мл) / unit of volume (1 L = 1000 mL)' },
    { term: 'миллилитр / milliliter', definition: 'одна тысячная литра / one thousandth of a liter' },
    { term: 'десятичная / decimal', definition: 'число с точкой (0.75) / a number with a decimal point' },
    { term: 'цель / goal', definition: 'сколько нужно достичь / target to reach' },
    { term: 'обратный процент / inverse percent', definition: 'находим целое по части и проценту / find whole from part + percent' },
    { term: 'калория / calorie', definition: 'единица энергии в еде (для примера в задаче) / unit of energy in food (task example)' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Литры и миллилитры / Liters and milliliters',
      prompt: 'Утро 0.45 л, день 0.75 л, вечер 0.6 л. Сколько литров всего? Переведи в миллилитры. Цель 2.4 л — сколько не хватило? / Total liters, convert to mL, difference from 2.4 L goal.',
      helper: 'Складывай десятичные; 1 л = 1000 мл. / Add decimals; 1 L = 1000 mL.',
      answer: '1.8 л = 1800 мл; не хватило 0.6 л. / 1.8 L = 1800 mL; missing 0.6 L.', unit: 'л / L' },
    { id: 'q2', type: 'math', title: 'Обратный процент по воде / Inverse percent (water)',
      prompt: 'Макс выпил 1.8 л — это 75% цели. Какая полная цель? / 1.8 L = 75% of goal. Find whole.',
      helper: '1.8 ÷ 0.75. / Divide by percent as decimal.',
      answer: '2.4 л. / 2.4 L.', unit: 'л / L' },
    { id: 'q3', type: 'math', title: 'Таблица калорий и остаток / Calorie table and percent',
      prompt: 'Яблоко 95, йогурт 140, сэндвич 320, сок 110. Взял яблоко + йогурт + сэндвич. Сколько всего? Какой процент от цели 600? / Total for 3 items; percent of 600.',
      helper: 'Сложи выбранные + ÷ 600. / Add then divide.',
      answer: '555 калорий; 92.5% цели. / 555 calories; 92.5% of goal.', unit: '' },
    { id: 'q4', type: 'math', title: 'Уравнение с бутылками / Bottle equation',
      prompt: '3 одинаковые бутылки и ещё 0.3 л = 2.1 л. Сколько литров в одной бутылке? Если бутылок будет 5, сколько литров? / 3x + 0.3 = 2.1; then 5x.',
      helper: 'Сначала реши уравнение, потом умножь. / Solve first, then multiply.',
      answer: '0.6 л в одной; 3 л в пяти. / 0.6 L each; 3 L for 5.', unit: 'л / L' },
    { id: 'q5', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'вода / water' },
        { id: 'w2', text: 'полезный / useful' },
        { id: 'w3', text: 'пить / to drink' },
        { id: 'w4', text: 'цель / goal' },
        { id: 'w5', text: 'ежедневный / daily' },
        { id: 'w6', text: 'считать / to count' }
      ] },
    { id: 'q6', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «вада помагает организму работать, а измерения памагают паказать сколько выпил». / Rewrite without mistakes.',
      placeholder: 'Вода помогает... / Water helps...' },
    { id: 'q7', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Измерять, чтобы видеть» на печатном листе. Запиши главную мысль, план из 3 пунктов и 4 предложения. / Read the print text; main idea, 3-point plan, 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q8', type: 'text', title: 'Логика: «пить больше» vs литры / Logic: "drink more" vs liters',
      prompt: 'Что полезнее для плана — сказать «пить больше» или записывать литры? Дай 2 причины и пример. / 2 reasons + example.',
      placeholder: 'Записать литры... / Writing liters...' },
    { id: 'q9', type: 'essay', title: 'Мой water/food log на день / My water/food log for one day',
      prompt: 'Заполни для одного дня: утро/день/вечер. Вода в литрах, перекусы с калориями (пример). Посчитай сумму. / One day log: water (L) and snacks (calories) for morning/day/evening; total.',
      minSentences: 4, maxSentences: 8, placeholder: 'Утро: 0.4 л воды, яблоко ...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 6, День 3». / Heading.',
    'Слой 1. Математика: q1 (л/мл), q2 (обратный %), q3 (калории и %), q4 (уравнение). / Math tasks.',
    'Слой 2. Русский: части речи + исправление. / Russian: parts of speech + correction.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: аргумент про измерения. / Logic.',
    'Слой 5. Практика: water/food log на день. / Practical log.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 6, День 3 / Week 6, Day 3',
    subtitle: 'Вода, питание, обратные проценты и уравнения / Water, Food, Inverse Percent and Equations',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: water/food log / Practical: water/food log — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: десятичные, литры/миллилитры, проценты, обратный процент, уравнение. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) 0.45 + 0.75 + 0.6 = ____ л. ____ л × 1000 = ____ мл. Цель 2.4 л; не хватило 2.4 − ____ = ____ л. / Sum, convert, difference.',
          '2) 1.8 ÷ 0.75 = ____ л (полная цель = 100%). / Inverse percent.',
          '3) 95 + 140 + 320 = ____ калорий. Процент цели 600: ____ ÷ 600 = ____ = ____%. / Sum and percent.',
          '4) 3x + 0.3 = 2.1. 3x = ____. x = ____ л. 5 × ____ = ____ л. / Bottle equation.',
          '5) Проверка / Check: 0.6 × 3 + 0.3 = ____ л? / Verify.',
          '6) 25% от 2.4 л = ____ л (сколько ещё осталось до цели). / 25% of 2.4 L.',
          '7) Optional / Доп.: если 92.5% от 600 = 555, найди 100% от 555 (обратный %): 555 ÷ 0.925 = ____. / Inverse percent.',
          '8) Optional / Доп.: 2.4 л − 1.8 л = 0.6 л; это ____% от 2.4 л. / Percent of 2.4.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: определяем часть речи по вопросу; проверяем безударную гласную по ударному слову. / Part of speech by question; vowel by stress.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: вода, литр, миллилитр, измерение, процент, уравнение, цель, польза.',
          'Части речи / Parts of speech: вода, полезный, пить, цель, ежедневный, считать — раздели.',
          'Исправь ошибки / Fix mistakes: «вада помагает организму работать, а измерения памагают паказать сколько выпил».',
          'Мини-диктант / Mini-dictation: «Измерения помогают увидеть, сколько воды и еды получил организм за день».',
          'Орфограмма дня / Spelling rule: безударные проверяемые гласные и −тся/−ться. / Unstressed vowels + −tsya.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Измерять, чтобы видеть» / Text: Когда мы измеряем, мы видим то, что раньше только чувствовали. Слова «мало» и «много» разные для каждого. А литры и калории одинаковые для всех. Поэтому, если Макс запишет цифры, план становится честнее: видно, где не хватает воды, где слишком много сладкого, а где всё в норме. Измерения помогают заметить проблему до того, как она станет большой. / Measuring lets us see what we only felt. "Little" and "a lot" differ for everyone; liters and calories are the same for all. Numbers make a plan honest. Measuring spots issues early.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения об измерениях / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Сравни две стратегии: A — «пить больше», B — записывать литры. / Compare A vs B.' },
        { type: 'list', items: [
          'Что можно проверить в A? / Can A be checked?',
          'Что можно проверить в B? / Can B be checked?',
          'Если цель 2.4 л и Макс выпил 1.8 л, какая стратегия найдёт разницу быстрее? / Which finds the gap faster?',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: «пить больше» — совет; литры — измеримая цель. Проверяемое лучше. / Measurable beats vague.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: water/food log / Layer 5. Practical Knowledge: Water/Food Log', blocks: [
        { type: 'text', text: 'Это не медицинский совет. Не отслеживай вес, калории регулярно, лекарства. Это учебный пример на один день. / Not medical advice.' },
        { type: 'list', items: [
          'Утро / Morning: вода ____ л; перекус ____ (кал ____).',
          'День / Day: вода ____ л; перекус ____ (кал ____).',
          'Вечер / Evening: вода ____ л; перекус ____ (кал ____).',
          'Итого воды / Total water: ____ л.',
          'Итого калорий (пример) / Total calories (example): ____.',
          'Цель воды / Water goal: 2.4 л. Разница / Difference: ____ л.',
          'Цель перекуса / Snack goal (пример): 600 кал. Разница / Difference: ____.'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Самое важное про измерения сегодня / Most important about measuring today: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за обратный процент и уравнение / Bonus for inverse percent + equation: +1 ☐',
          'Бонус за понятный water/food log / Bonus for a clear log: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: десятичные, л/мл, проценты, обратный процент, уравнение с одной переменной. Русский Grade 3–4: части речи и исправление. / Solid Grade 6 math + Grade 3–4 Russian.',
    mathGoal: 'q1: 1.8 л = 1800 мл; не хватило 0.6 л. q2: 2.4 л (обратный %). q3: 555 кал = 92.5% от 600. q4: x = 0.6; 5 × 0.6 = 3 л. / Listed with steps.',
    russianGoal: 'Существительные: вода, цель. Глаголы: пить, считать. Прилагательные: полезный, ежедневный. / Correct parts of speech.',
    readingWritingGoal: 'Главная мысль: измерения делают план честным. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Water/food log на один день, разница с целями посчитана. / One-day log with gaps.',
    check: [
      'Q1: 1.8 л, 1800 мл, 0.6 л.',
      'Q2: 2.4 л.',
      'Q3: 555 кал, 92.5%.',
      'Q4: 0.6 л и 3 л.',
      'Части речи разобраны. / Parts of speech sorted.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Логика: измеримое > совета. / Measurable > advice.',
      'Water/food log посчитан. / Log computed.'
    ],
    answerKey: [
      { taskId: 'q1', answer: '0.45 + 0.75 + 0.6 = 1.8 л; 1800 мл; 2.4 − 1.8 = 0.6 л. / 1.8 L = 1800 mL; missing 0.6 L.' },
      { taskId: 'q2', answer: '75% = 0.75; 1.8 ÷ 0.75 = 2.4 л. / 2.4 L.' },
      { taskId: 'q3', answer: '95 + 140 + 320 = 555; 555 ÷ 600 = 0.925 = 92.5%. / 555 calories; 92.5%.' },
      { taskId: 'q4', answer: '3x + 0.3 = 2.1; 3x = 1.8; x = 0.6; 5 × 0.6 = 3 л. / 0.6 L each; 3 L for 5.' },
      { taskId: 'q5', answer: 'Существительные: вода, цель. Глаголы: пить, считать. Прилагательные: полезный, ежедневный.' },
      { taskId: 'q6', answer: 'Вода помогает организму работать, а измерения помогают показать, сколько выпил.' },
      { taskId: 'q7', answer: 'Главная мысль: измерения делают план честным. План: 1) слова «мало / много» разные; 2) литры и калории одинаковые; 3) измерения ловят проблему заранее. 4 предложения — открытый ответ.' },
      { taskId: 'q8', answer: '2 причины: измеримая цель проверяется; неизмеримая — открытая. Пример: 2.4 л vs «пей больше». / 2 reasons + example.' },
      { taskId: 'q9', answer: 'Открытый ответ; один день, вода в литрах + перекусы, разница с целями. / Open answer.' }
    ],
    spellingCheck: 'Части речи + −тся/−ться правильно. / Parts of speech + −tsya rule.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Что даёт запись цифр в план? / What do numbers add to a plan?',
      'Как понять, что вода достаточна? / How to tell if water is enough?',
      'Где легко заменить «много» на число? / Where is "a lot" easily replaced by a number?',
      'Что важнее для здоровья — регулярность или количество? / Regularity vs quantity?'
    ],
    ifEasy: 'Усложни: пусть Макс переведёт 1800 мл обратно в литры и найдёт, какой процент 1.8 л от 3 л. / Extend: reverse convert and find 1.8/3.',
    ifDifficult: 'Оставь q1 и q4. / Keep q1 and q4.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'inverse-eq', label: 'Бонус за обратный процент и уравнение / Bonus for inverse percent + equation', amount: 1 },
      { id: 'clean-log', label: 'Бонус за понятный log / Bonus for a clear log', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q7', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-6', dayId: 'day-2' },
  nextLessonId: 'max-week-6-day-4'
};

export default maxWeek6Day3;
